import axios from 'axios'

const api = async (method, path, params) => axios[method](path, params)
const state = {
    selectedType: {},
    types: [],
}

const mutations = {
    SET_SELECTED_RECORD(state, payload) {
        state.selectedType = payload
    },
    SET_RECORDS(state, payload) {
        state.types = payload
    },
}

const actions = {
    /**
     * Set the selected template for a new template
     */
    newRecord(context, payload) {
        context.commit('SET_SELECTED_RECORD', payload)
    },
    async create(context, payload) {
        try {
            const results = await api('post', `checkoff`, payload)
            context.commit('SET_SELECTED_RECORD', results.data.success.data)
        } catch (err) {
            throw err
        }
    },
    async fetchById(context, template_id) {
        try {
            const results = await api('get', `checkoff/${template_id}`)           
            context.commit('SET_SELECTED_RECORD', results.data.success.data)
        } catch (err) {
            throw err
        }
    },

    async fetchAll(context) {
        try {
            const results = await api('get', `checkoff`)
            context.commit('SET_RECORDS', results.data.success.data)
        } catch (err) {
            throw err
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `checkoff/${payload.id}`,
                payload
            )
            context.commit('SET_SELECTED_RECORD', results.data.success.data)
        } catch (err) {
            throw err
        }
    },
    async delete(context, template_id) {
        try {
            await api('delete', `checkoff/${template_id}`)
            context.commit('SET_SELECTED_RECORD', null)
            context.dispatch('fetchAll')
        } catch (err) {
            throw err
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
